import { Chip, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { TFunction } from 'i18next';
import { SapMovementState } from '../../../../constants';

interface StateConfig {
  icon: React.ReactElement;
  color: 'default' | 'info' | 'warning' | 'success' | 'error';
}

const stateConfig: Record<string, StateConfig> = {
  [SapMovementState.NOT_SENT]: {
    icon: <LockOpenIcon />,
    color: 'info'
  },
  [SapMovementState.SENT]: {
    icon: <CloudSyncIcon />,
    color: 'warning'
  },
  [SapMovementState.ACCEPTED]: {
    icon: <CheckIcon />,
    color: 'success'
  },
  [SapMovementState.REJECTED]: {
    icon: <ErrorIcon />,
    color: 'error'
  }
};

function sapStateCell(t: TFunction) {
  return function renderCell(params: GridRenderCellParams) {
    const state = params.value as string;
    const row = params.row as { sap_goods_receipt_response_message?: string };

    if (!state) {
      return null;
    }

    const config = stateConfig[state] || {
      icon: <HelpOutlineIcon />,
      color: 'default' as const
    };

    const label = t(`entities.movement.sap_state.${state}`, { defaultValue: state });
    const description = t(`entities.movement.sap_state.tooltip.${state}`, {
      defaultValue: ''
    });

    let tooltip = label;
    if (description) {
      tooltip = `${tooltip} — ${description}`;
    }

    if (state === SapMovementState.REJECTED && row?.sap_goods_receipt_response_message) {
      tooltip = `${tooltip} ${t('entities.movement.sap_state.rejected_message', {
        message: row.sap_goods_receipt_response_message
      })}`;
    }

    return (
      <Tooltip title={tooltip} arrow placement="top">
        <Chip
          icon={config.icon}
          label={label}
          color={config.color}
          size="small"
          variant="outlined"
        />
      </Tooltip>
    );
  };
}

export default sapStateCell;
